{
  "_meta": {
    "_comment": "Phase 18 Wave 6 Task 34 — admin Vendor Detail > Integration tab. vg-binding: P18.D-21 | vg-binding: P18.D-28 | vg-binding: PLAN:task-34 || Phase 18 Wave 7 Task 36 — the ops.* subtree is the FLEET health widget on the vendors list (IntegrationHealthWidget.tsx). vg-binding: P18.D-13 | vg-binding: P18.D-35 | vg-binding: PLAN:task-36",
    "locale": "en"
  },
  "tab": {
    "title": "Integration",
    "description": "API keys, webhook endpoint and delivery log for this vendor's machine lane."
  },
  "gate": {
    "heading": "Machine lane",
    "statusLabel": "Effective state",
    "effectiveOn": "Keys can call the API",
    "effectiveOff": "Calls are refused",
    "blockedLane": "The global vendor API switch is off, so every vendor is refused regardless of this toggle.",
    "blockedVendor": "This vendor's integration is off, so its keys are refused while the lane stays open for others.",
    "laneLabel": "Global lane",
    "vendorLabel": "This vendor",
    "on": "On",
    "off": "Off",
    "toggleOn": "Turn integration on",
    "toggleOff": "Turn integration off",
    "toggling": "Saving…",
    "successOn": "Integration turned on",
    "successOff": "Integration turned off",
    "error": "Could not change the integration switch",
    "readOnly": "You can read this vendor's integration, but changing it needs the vendor management permission."
  },
  "keys": {
    "title": "API Keys",
    "description": "Keys this vendor uses to call the Vendor API. Revoked keys stay listed for support history.",
    "create": "Create API key",
    "creating": "Creating…",
    "empty": "This vendor has no API key yet.",
    "labelLabel": "Key label",
    "labelPlaceholder": "e.g. production system",
    "labelRequired": "Enter a label before creating the key.",
    "columns": {
      "key": "Key",
      "created": "Created",
      "lastUsed": "Last used",
      "createdBy": "Created by",
      "status": "Status",
      "actions": "Actions"
    },
    "status": {
      "active": "Active",
      "revoked": "Revoked"
    },
    "role": {
      "vendor_owner": "Vendor owner",
      "admin": "Admin"
    },
    "never": "Never",
    "revoke": "Revoke",
    "revoking": "Revoking…",
    "confirm": {
      "title": "Revoke this API key?",
      "description": "The key stops working immediately and the vendor's owners are notified. This cannot be undone.",
      "confirmLabel": "Revoke key"
    },
    "created": {
      "title": "API key created",
      "description": "Copy it now — it is shown only once and cannot be read again.",
      "warning": "This key is shown only once. Store it securely.",
      "copy": "Copy",
      "copied": "Copied",
      "copyFailed": "Copy failed — select the key text and copy it manually.",
      "saved": "I have saved this key",
      "done": "Done"
    },
    "toast": {
      "createdTitle": "API key created",
      "createdBody": "Copy the key before leaving this panel.",
      "revokedTitle": "API key revoked",
      "revokedBody": "The key no longer authenticates.",
      "errorTitle": "Key operation failed"
    }
  },
  "webhook": {
    "title": "Webhook Endpoint",
    "description": "Where this vendor receives event payloads.",
    "urlLabel": "Webhook URL",
    "noUrl": "No endpoint registered.",
    "statusLabel": "Status",
    "status": {
      "unset": "Not set",
      "unverified": "Unverified",
      "verified": "Verified",
      "auto_disabled": "Auto-disabled"
    },
    "verifiedAtLabel": "Verified at",
    "failuresLabel": "Consecutive failures",
    "vendorOnlyNote": "The URL and the signing secret are changed by the vendor in its own portal; admins read them here."
  },
  "deliveries": {
    "title": "Delivery Log",
    "description": "Webhook attempts for this vendor, newest first.",
    "filterLabel": "Status",
    "filterAll": "All statuses",
    "status": {
      "delivered": "Delivered",
      "retrying": "Retrying",
      "failed": "Failed",
      "suppressed": "Suppressed"
    },
    "columns": {
      "event": "Event",
      "status": "Status",
      "attempts": "Attempts",
      "lastAttempt": "Last attempt",
      "response": "Response"
    },
    "empty": "No delivery attempt recorded yet.",
    "previous": "Previous",
    "next": "Next",
    "attemptsValue": "{{attempt}} / {{max}}",
    "noResponse": "No response",
    "refreshing": "Refreshing…",
    "showing": "Showing {{count}} attempts"
  },
  "ops": {
    "title": "Integration health",
    "description": "Vendor webhook deliveries across every vendor, last {{hours}} hours.",
    "loading": "Loading integration health…",
    "loadFailed": "Could not load integration health: {{message}}",
    "retry": "Try again",
    "refreshing": "Refreshing…",
    "generatedAt": "Measured at {{time}}",
    "lane": {
      "label": "Outbound lane",
      "on": "Sending",
      "off": "Not sending",
      "lane_disabled": "The vendor API kill switch is off. Nothing is being sent and every delivery logged as suppressed was stopped on purpose — this is not an outage.",
      "dispatch_lane_off": "The outbound webhook dispatch flag is off. Nothing is being sent and every delivery logged as suppressed was stopped on purpose — this is not an outage."
    },
    "events": {
      "failedLabel": "Failed events ({{hours}}h)",
      "ofSettled": "of {{settled}} settled events",
      "delivered": "Delivered",
      "retrying": "Retrying",
      "suppressed": "Suppressed",
      "suppressedNote": "One event counts once, however many retries it took. Suppressed deliveries were stopped by a switch, so they are never counted as failures."
    },
    "vendors": {
      "label": "Vendors failing",
      "value": "{{failing}} of {{active}}"
    },
    "endpoints": {
      "label": "Auto-disabled endpoints",
      "value": "{{count}} of {{total}}",
      "vendors": "across {{count}} vendors"
    },
    "queue": {
      "label": "Dispatch queue",
      "value": "{{waiting}} waiting · {{active}} running · {{delayed}} delayed",
      "unreachable": "Queue unreachable",
      "paused": "Queue paused"
    },
    "alert": {
      "warning": "Fleet warning",
      "critical": "Fleet incident",
      "hint": "A break this wide is usually ours — check the dispatch worker, its signing key and outbound DNS/TLS before contacting vendors.",
      "notified": "An admin notification was sent for this.",
      "reason": {
        "fleet_failure_rate": "{{vendors}} vendors are failing at once — {{observed}} of settled events failed, over the {{threshold}} bound.",
        "auto_disable_spike": "{{observed}} endpoints were auto-disabled across {{vendors}} vendors, over the {{threshold}} bound."
      }
    }
  },
  "errors": {
    "loadFailed": "Could not load the integration data: {{message}}",
    "retry": "Try again"
  },
  "common": {
    "loading": "Loading…"
  }
}
